import React from 'react';
import '../../../styles.scss';

import {  OwcTypography,  OwcExpandable,
  OwcTable, OwcTableHeader, OwcTableHeaderCell,
  OwcTableBody, OwcTableRow, OwcTableCell,
  OwcComponentHeader, OwcComponentFooter, OwcButton, OwcSwitch,
  OwcPagination
} from '@one/react';
import DelayedTooltip from "../../../components/general/DelayedTooltip.js";
import {convertToDate, formatDate} from "../../../shared/Utilities.js";


/**
 * @copyright Roche 2025
 * @author Nick Draper
 */

/**
 * Specific control for displaying the Country report results
 */
class CountryReportResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resultsExpanded: true,
      hideDeviceDetails: false,
      hidePurposeMapping: false,
      sortBy:"serialNumber",
      sortOrder:"default",
      rowsPerPage: 10,
      page: 1
    }
  }


  handlePaginationChange(ev) {
    let newPage = ev.detail.page;
    if (ev.detail.pageSize !== this.state.rowsPerPage) {
      newPage=1
    }
    if ((this.state.page !== newPage) || (ev.detail.pageSize !== this.state.rowsPerPage)) {
      this.setState({rowsPerPage: ev.detail.pageSize,
                      page: newPage});
      }
  }


  handleSortChange(itemName, sortOrder) {
    if (this.state.sortBy !== itemName) {
      if(sortOrder!=="default") {
        this.setState({
          sortBy: itemName,
          sortOrder: "asc",
          page: 1
        });
      }
    } else if (this.state.sortOrder !== sortOrder) {
      this.setState({
        sortBy: itemName,
        sortOrder: sortOrder,
        page: 1
      });
    }
  }

  nullSafeCompareFn(a, b, sortBy) {
    if (a[sortBy] === null) {
      return 1;
    }   
    if (b[sortBy] === null) {
      return -1;
    }
    return a[sortBy].localeCompare(b[sortBy])
  }

  renderResultsTable() {
    const report = this.props.report.countryReport;
    let deviceList = report.data.devices;
    const deviceColor = "--one-color-chart-blue-100";
    const purposeColor = "--one-color-green-200";
    if (deviceList === undefined) { 
      return("Device list Not Found");
    }
    const dupSummary = report.data.summary.dataUsePurposes;
    const colCount = 2 + (this.state.hideDeviceDetails?0:4) + (this.state.hidePurposeMapping?0:dupSummary.length);
    const baseWidth = 100/colCount;
    const totalPages = Math.ceil(deviceList.length / this.state.rowsPerPage);
    const firstDeviceIndex = (this.state.page-1) * this.state.rowsPerPage
    const lastDeviceIndex = firstDeviceIndex + this.state.rowsPerPage
    
    const sortBy = this.state.sortBy;
    if (this.state.sortOrder === "asc") {
      deviceList = deviceList.toSorted((a, b)=>this.nullSafeCompareFn(a, b, sortBy))
    } else if  (this.state.sortOrder === "desc")  {
      deviceList = deviceList.toSorted((b, a)=>this.nullSafeCompareFn(a, b, sortBy))
    } 

    return(
      <OwcTable key={"deviceListTable" + colCount} size='dense' elevated
        stickyColumnBeginning="2"
      >
        <OwcTableHeader sticky>
            <OwcTableHeaderCell key="titledeviceListRefSystemType" width={`${baseWidth}%`}
              sortable onSortOrderChange={(ev)=>{this.handleSortChange("referenceSystemType", ev.detail)}}
              sortOrder={this.state.sortBy==="referenceSystemType"?this.state.sortOrder:"default"}>Ref System Type</OwcTableHeaderCell>
            <OwcTableHeaderCell key="titledeviceListSerialNo" width={`${baseWidth}%`}
              sortable onSortOrderChange={(ev)=>{this.handleSortChange("serialNumber", ev.detail)}}
              sortOrder={this.state.sortBy==="serialNumber"?this.state.sortOrder:"default"}>Serial No</OwcTableHeaderCell>
            {this.state.hideDeviceDetails?
              ""
            :
              <>
                <OwcTableHeaderCell key="titledeviceListMaterialNumber" width={`${baseWidth}%`} style={{backgroundColor: `var(${deviceColor})`}}
                  sortable onSortOrderChange={(ev)=>{this.handleSortChange("materialNumber", ev.detail)}}
                  sortOrder={this.state.sortBy==="materialNumber"?this.state.sortOrder:"default"}>Material Number</OwcTableHeaderCell>
                <OwcTableHeaderCell key="titledeviceListLabId" width={`${baseWidth}%`} style={{backgroundColor: `var(${deviceColor})`}}
                  sortable onSortOrderChange={(ev)=>{this.handleSortChange("labId", ev.detail)}}
                  sortOrder={this.state.sortBy==="labId"?this.state.sortOrder:"default"}>Lab ID</OwcTableHeaderCell>
                <OwcTableHeaderCell key="titledeviceListLastUploadDate" width={`${baseWidth}%`} style={{backgroundColor: `var(${deviceColor})`}}
                  sortable onSortOrderChange={(ev)=>{this.handleSortChange("lastUploadDate", ev.detail)}}
                  sortOrder={this.state.sortBy==="lastUploadDate"?this.state.sortOrder:"default"}>Last Upload Date</OwcTableHeaderCell>
                <OwcTableHeaderCell key="titledeviceListDeviceLocation" width={`${baseWidth}%`} style={{backgroundColor: `var(${deviceColor})`}}
                  sortable onSortOrderChange={(ev)=>{this.handleSortChange("instrumentLocation", ev.detail)}}
                  sortOrder={this.state.sortBy==="instrumentLocation"?this.state.sortOrder:"default"}>Instrument Location</OwcTableHeaderCell>
              </>
            }
            {this.state.hidePurposeMapping?
              ""
            :
              dupSummary.map(item => this.renderDUPColumn(item, baseWidth, purposeColor))
            }
        </OwcTableHeader>
        <OwcTableBody>
          {deviceList.map((item, index) => {
            if ((index >= firstDeviceIndex) &&
                (index < lastDeviceIndex)) {
              return this.renderResultsRow(item)
            } else { 
              return("") 
            }
          })}
        </OwcTableBody>
        <OwcComponentHeader slot="header">
          Connected Devices ({firstDeviceIndex+1} to {lastDeviceIndex>deviceList.length?deviceList.length:lastDeviceIndex} of {deviceList.length})
          <div slot="suffix" style={{ display: 'flex', alignItems: 'center', gap:"1em" }}>
            <OwcButton onClick={()=>this.props.onDownloadClick()}>Download File</OwcButton>
            <OwcSwitch style={{backgroundColor: `var(${deviceColor})`}}
              checked={this.state.hideDeviceDetails}
              onValueChange={(ev)=>{this.setState({hideDeviceDetails:ev.detail})}}
            >
              Hide Device Details
            </OwcSwitch>
            <OwcSwitch style={{backgroundColor: `var(${purposeColor})`}}
              checked={this.state.hidePurposeMapping}
              onValueChange={(ev)=>{this.setState({hidePurposeMapping:ev.detail})}}
            >
              Hide Purpose Mapping
            </OwcSwitch>
          </div>
        </OwcComponentHeader>
         <OwcComponentFooter slot="footer">
            <OwcPagination slot="suffix" pageSizeOptions={[10, 20, 50]}
              page={this.state.page}
              total={totalPages}
              pageSize={this.state.rowsPerPage}
              onPageChange={(ev)=>{this.handlePaginationChange(ev)}}
              >
              <div slot="rows-per-page"> Rows per Page </div>
            </OwcPagination>
        </OwcComponentFooter>
      </OwcTable>
    );
  }
  
  renderDUPColumn(item, baseWidth, color) {
    return (
      <OwcTableHeaderCell 
        key={"titledeviceList" + item.description} 
        width={`${baseWidth}%`}  
        style={{backgroundColor: `var(${color})`}}>
          {item.description}
      </OwcTableHeaderCell>
    );
  }

  renderResultsRow(item) {
    const keyEnding = item.referenceSystemType+item.serialNumber;
    const report = this.props.report.countryReport;
    const dupSummary = report.data.summary.dataUsePurposes;
    return(
      <OwcTableRow
          key={"rowDeviceList" + keyEnding}
          id={"rowDeviceList" + keyEnding}>
        <OwcTableCell 
            style={{wordBreak:"normal"}} 
            key={"DeviceListRefSystemTypeCell" + keyEnding} valign="middle">
            {item.referenceSystemType}
        </OwcTableCell>
        <OwcTableCell style={{wordBreak:"normal"}} 
            key={"DeviceListSerialNoCell" + keyEnding} valign="middle">
          {item.serialNumber}
        </OwcTableCell>
          {this.state.hideDeviceDetails?
            ""
          :
            <>
              <OwcTableCell style={{wordBreak:"normal"}}
                  key={"DeviceListMaterialNumberCell" + keyEnding} valign="middle">
                {item.materialNumber}
              </OwcTableCell>
              <OwcTableCell style={{wordBreak:"break-all"}}
                  key={"DeviceListLabIdCell" + keyEnding} valign="middle">
                {item.labId}
              </OwcTableCell>
              <OwcTableCell style={{wordBreak:"normal"}} 
                  key={"DeviceListLastUploadDateCell" + keyEnding} valign="middle">
                {formatDate(convertToDate(item.lastUploadDate))}
              </OwcTableCell>
              <OwcTableCell style={{wordBreak:"normal"}} 
                  key={"DeviceListDeviceLocationCell" + keyEnding} valign="middle">
                {item.instrumentLocation}
              </OwcTableCell>
            </>
          }
        {this.state.hidePurposeMapping?
          ""
        :
          dupSummary.map(purpose => this.renderDUPCell(purpose, item))
        }
      </OwcTableRow>
    );
  }

  renderDUPCell(purpose, device) {
    const keyEnding = purpose.description + device.referenceSystemType + device.serialNumber;
    const usedPurposeList = device.dataUsePurposes;
    const matchingPurposeEntry = usedPurposeList.find(purposeEntry => purposeEntry.description === purpose.description);
    
    if (matchingPurposeEntry === undefined) {
        return(
          <OwcTableCell 
                style={{wordBreak:"normal"}} 
                key={"DeviceListRefPurposeCell" + keyEnding} valign="middle">
                  &nbsp;
          </OwcTableCell>
        );
    }
    else
    {
      const sortedIdList = matchingPurposeEntry.dataUseIds.sort();
      const idListLength = sortedIdList.length;
      return(
        <OwcTableCell 
              style={{wordBreak:"normal"}} 
              key={"DeviceListRefPurposeCell" + keyEnding} valign="middle">
                {sortedIdList.map((dataUseId, index) => this.renderdataUseLabel(dataUseId, keyEnding, idListLength === (index+1)))}
        </OwcTableCell>
      );
    }
  }

  renderdataUseLabel(dataUseId, keyEnding, isLastEntry) {
    const duSummary = this.props.report.countryReport.data.summary.dataUses;
    const matchingDataUseEntry = duSummary.find(dataUseEntry => dataUseEntry.dataUseId === dataUseId);
    const completeKey = "DeviceListRefPurposeCell" + keyEnding + dataUseId


    return (
      <>
      <OwcTypography key={completeKey} id={completeKey}>{dataUseId}{isLastEntry?"":", "}</OwcTypography>
      {(matchingDataUseEntry !== undefined)?
        <DelayedTooltip anchor={completeKey} key={completeKey+"Tooltip"}>
          {matchingDataUseEntry.name}
        </DelayedTooltip>
      :
        ""
      }
      </>
    );
  }

  /**
  * Renders the specification section for the Data Product
  * @returns formatted JSX
  */
  render() {
    if (!this.props.report?.countryReport) {
      // There was an error, it'll be displayed by the CountryReportOverview
      return ("");
    }

    const report = this.props.report.countryReport;
    return (
      <div style={{ marginLeft: "2em", marginRight: "2em"}}>
        <OwcExpandable roundedControl variant="transparent"
            expanded={this.state.resultsExpanded}
            onExpandedChange={(ev) => { this.setState({ resultsExpanded: ev.detail }) }}>
          <span slot="title">
            <OwcTypography variant="title6">
              Report Results - {report.data.devices.length} device{report.data.devices.length!==1?"s":""}
            </OwcTypography>
          </span>
          <span slot="content">
            {this.renderResultsTable()}
          </span>
        </OwcExpandable>
      </div>
    );
  }
}

export default CountryReportResults;
